import IPersonalDetails from './interfaces/IPersonalDetails';

export default class PersonalDetails implements IPersonalDetails {
  public title: string | null = null;

  public firstName: string = '';

  public surname: string = '';

  public telephone: string = '';

  public email: string = '';
}
